// extracted by mini-css-extract-plugin
module.exports = {"container":"Settings_container__3G-4E","content":"Settings_content__15o1T","nav":"Settings_nav__3nPLs"};